import {useEffect, RefObject} from 'react';

type Event = MouseEvent | TouchEvent;

const useOnOutsideClick = <T extends HTMLElement = HTMLElement>(ref: RefObject<T>, eventHandler: (event: Event) => void) => {

  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref?.current;

      if (!el || el.contains((event?.target as Node) || null)) return null;

      eventHandler(event);
    }

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    }
  }, [ref, eventHandler]);
}

export default useOnOutsideClick;